import React from 'react';
import { motion } from 'framer-motion';
import { PawPrint, Scissors, Heart, GraduationCap, Camera, Cookie, Home, Clock, Sparkles, Gamepad2, Award, ImageIcon, Droplet, KeyRound } from 'lucide-react';
const services = [{
  title: 'Sprehajanje psov',
  icon: PawPrint,
  color: 'bg-brand-pink-light',
  iconColor: 'text-brand-pink'
}, {
  title: 'Osnovno česanje',
  icon: Scissors,
  color: 'bg-brand-green-light',
  iconColor: 'text-brand-green'
}, {
  title: 'Igra in aktivacija psa',
  icon: Gamepad2,
  color: 'bg-brand-brown-light',
  iconColor: 'text-brand-brown'
}, {
  title: 'Učenje osnovnih trikcev',
  icon: Award,
  color: 'bg-brand-pink-light',
  iconColor: 'text-brand-pink'
}, {
  title: 'Pošiljanje slikic lastnikom po sprehodu',
  icon: Camera,
  color: 'bg-brand-green-light',
  iconColor: 'text-brand-green'
}, {
  title: 'Voda in priboljški med sprehodom',
  icon: Cookie,
  color: 'bg-brand-brown-light',
  iconColor: 'text-brand-brown'
}, {
  title: 'Obisk na domu za hranjenje med dopustom',
  icon: Home,
  color: 'bg-brand-pink-light',
  iconColor: 'text-brand-pink'
}, {
  title: 'Krajši ali daljši sprehodi',
  icon: Clock,
  color: 'bg-brand-green-light',
  iconColor: 'text-brand-green'
}];
export function Services() {
  return <section className="py-12 px-6 max-w-7xl mx-auto" id="storitve" data-id="element-98">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="text-center mb-10" data-id="element-99">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-100">
          Kaj ponujava
        </h2>
        <p className="text-lg text-brand-text/70 max-w-2xl mx-auto" data-id="element-101">
          Poskrbiva za vse, kar vaš kuža potrebuje za srečen in aktiven dan.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-102">
        {services.map((service, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        delay: index * 0.1
      }} className={`${service.color} rounded-3xl p-6 flex flex-col items-center text-center transition-all duration-300 hover:scale-105 hover:-rotate-1 hover:shadow-lg cursor-default group`} data-id="element-103">
            <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mb-4 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-104">
              <service.icon className={`w-8 h-8 ${service.iconColor}`} data-id="element-105" />
            </div>
            <h3 className="font-bold text-brand-text text-lg leading-tight" data-id="element-106">
              {service.title}
            </h3>
            {service.description}
          </motion.div>)}
      </div>
    </section>;
}